import type { ReactNode } from 'react';
import { fieldRow } from './Field.css';

export function FieldRow({ children }: { children: ReactNode }) {
  return <div className={fieldRow}>{children}</div>;
}
